export default "__VITE_ASSET__B5F9qvns__"